/*
  This file contains the styles for the main components.
  It contains the following styles:
  - DialogHeader: The header for the dialog.
  - DialogFooter: The footer for the dialog.
*/

import { Box, styled } from '@mui/material';

// This is for Dialog Header - where we would show title and close icon.
export const DialogHeader = styled(Box)({
  position: 'relative',
  padding: '15px 20px 10px 20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid lightGray',
  '& .title': {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '27.32px',
    color: 'rgba(0, 0, 0, 1)',
    marginBottom: 0,
  },
  '& .closeIcon': {
    '& svg': {
      fontSize: 20,
      '& path': {
        fill: '#616161',
      },
    },
  },
});

// This if for Dialog Footer - where we would show cancel and submit button.
export const DialogFooter = styled(Box)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  gap: 10,
  borderTop: '1px solid lightGray',
  padding: '20px 20px 20px 20px',

  '& .cancelBtn': {
    fontWeight: 600,
    fontSize: 15,
    lineHeight: '26px',
    color: 'rgba(66, 66, 66, 1)',
  },
  '& .submitBtn': {
    backgroundColor: 'rgba(211, 47, 47, 1)',
    fontWeight: 600,
    fontSize: 15,
    lineHeight: '26px',
    borderRadius: 9,
    height: 42,
  },
});
